import { createInteractiveColorVar } from '../../helpers/createInteractiveColorVar/index.js';

const ControlBorderColors = createInteractiveColorVar('controls-border');
const ControlBorderColorsLightValues = Object.freeze({
    default: '#E0E0E0',
    action: '#E0E0E0',
    active: '#E0E0E0',
    activeAction: '#E0E0E0',
});
const ControlBorderColorsDarkValues = Object.freeze({
    default: '#3B3B3B',
    action: '#3B3B3B',
    active: '#3B3B3B',
    activeAction: '#3B3B3B',
});

export { ControlBorderColors, ControlBorderColorsDarkValues, ControlBorderColorsLightValues };
